import Fn from "../../Fn"

class SectionFive {
  constructor () {
    this.$slickNavBar = $('.slickNavBar')
    this.$slickForBox = $('.slickForBox')
    this.$slickFor = $('#sectionFive .slickFor')
    this.$infoBox = $('#sectionFive .infoBox')
    
    this.init()
  }
  
  init () {
    //  init slick item background image
    this._slickItemImagesHandler()
    
    this._slickCall()
    this._mobileSlickHandler()
    
    this._event()
  }
  
  _mobileSlickHandler () {
    this.$slickFor.on('beforeChange', (ev, slick, currentIndex, nextIndex) => {
      this.$slickNavBar.children().eq(nextIndex).addClass('active').siblings().removeClass('active')
      this.$infoBox.slick('slickGoTo', nextIndex)
    })
    
    this.$slickFor.slick({
      fade: true,
      swipe: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false//  自动高度取消
    })
    
    this.$infoBox.slick({
      fade: true,
      swipe: false,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false//  自动高度取消
    })
  }
  
  _event () {
    this.$slickNavBar.children().on('click', ev => {
      let target = ev.currentTarget
      let index = $(target).index()
      
      this.$slickForBox.slick('slickGoTo', index)
      this.$slickFor.slick('slickGoTo', index)
    })
  }
  
  _slickCall () {
    this.$slickForBox.on('init', () => this.$slickNavBar.children().eq(0).addClass('active'))
    this.$slickForBox.on('beforeChange', (ev, slick, currentIndex, nextIndex) => this.$slickNavBar.children().eq(nextIndex).addClass('active').siblings().removeClass('active'))
    this.$slickForBox.slick({
      fade: true,
      swipe: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false//  自动高度取消
    })
  }
  
  _slickItemImagesHandler () {
    this.$slickForBox.find('.slick--item').map((k, el) => {
      let images = JSON.parse(el.dataset.slickImages)
      let randomString = Fn.randomString()
      
      el.classList.add(randomString)
      Fn.writeStyle(`${randomString}Style`, `.${randomString}{background-image: url('${images.tab}?random=${window.randomString}');background-size:cover;}
                                            @media(min-width: ${window.breakPoints.pc}px){.${randomString}{background-image: url('${images.pc}?random=${window.randomString}')}}`);
      
      let randomString2 = Fn.randomString()
      let div = $(`<div class="${randomString2} slick--item" />`)
      Fn.writeStyle(`${randomString2}Style`, `@media(max-width: 767px){.${randomString2}{background-image: url('${images.mb}?random=${window.randomString}')}}`);
      this.$slickFor.append(div)
      this.$infoBox.append(`<div class="info--item">${$(el).find('.info').html()}</div>`)
      
      //  计算slick for item 的高度
      this.slickNavItemSizeCalc()
      $(window).resize(() => this.slickNavItemSizeCalc())
    })
  }
  
  /**
   * 计算slick for item 的高度
   */
  slickNavItemSizeCalc () {
    let width = this.$slickForBox.outerWidth()
    if (window.innerWidth >= window.breakPoints.pc) {
      this.$slickForBox.find('.slick--item').height(Math.floor(width * 0.3702))
    } else {
      this.$slickForBox.find('.slick--item').height(Math.floor(width * 0.8093))
    }
    
    let width2 = this.$slickFor.outerWidth()
    this.$slickFor.find('.slick--item').css({
      width: width2,
      height: Math.floor(width2 * 1.7777)
    })
  }
}

export default SectionFive
